import * as React from "react";
import { ConsentContentNode } from "../../types/client-forms.types";

interface ConsentFormContentProps {
    content: ConsentContentNode[];
}

function renderNode(node: ConsentContentNode, key: string): React.ReactNode {
    if (node.type === "text") {
        return node.text ?? "";
    }

    const allowedTags = ["div", "p", "a", "strong", "em", "span"] as const;
    const tag = allowedTags.includes(node.type as (typeof allowedTags)[number])
        ? (node.type as (typeof allowedTags)[number])
        : "span";
    const props: React.HTMLAttributes<HTMLElement> & {
        href?: string;
        target?: string;
        rel?: string;
        key: string;
    } = {
        className: node.className,
        key,
    };

    if (tag === "a") {
        props.href = node.href;
        props.target = "_blank";
        props.rel = "noreferrer";
    }

    return React.createElement(
        tag,
        props,
        (node.children ?? []).map((child, index) =>
            renderNode(child, `${key}-${index}`)
        )
    );
}

export default function ConsentFormContent({
    content,
}: ConsentFormContentProps) {
    return <>{content.map((node, index) => renderNode(node, `${index}`))}</>;
}
